<template>
    <voffice-popup-box :trigger-id="triggerId"
        class="full-xxs"
        :apply-label="applyLabel"
        @closed="onClosed">
        <table class="guestbox"
            aria-live="polite">
            <thead class="sr-only">
                <tr>
                    <th scope="col">{{ voMsg('tpl.label') }}</th>
                    <th scope="col">{{ voMsg('tpl.decrement') }}</th>
                    <th scope="col">{{ voMsg('tpl.increment') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(l, what) in sections"
                    :key="what"
                    class="gb-row">
                    <td class="gb-td label">
                        <label>{{ getFieldLabel(what) }}</label>
                        <div class="age"
                            v-if="what === 'adults'">{{ voMsg('tpl.adults.age') }}</div>
                        <div class="age"
                            v-if="what === 'children'">{{ voMsg('tpl.children.age') }}</div>
                        <div class="age"
                            v-if="what === 'babys'">{{ voMsg('tpl.baby.age') }}</div>
                    </td>
                    <td class="gb-td">
                        <button class="btn btn-default"
                            :aria-label="labelMinus()"
                            :disabled="!canDecr(what)"
                            @click="inc(what, -1)"
                            type="button">
                            <i class="fa-sharp fa-light fa-circle-minus icon"></i>
                            <span class="sr-only">{{ labelMinus(what) }}</span>
                        </button>
                    </td>
                    <td class="gb-td">
                        <button class="btn btn-default"
                            :aria-label="labelPlus()"
                            :disabled="!canInc(what)"
                            @click="inc(what, 1)"
                            type="button">
                            <i class="fa-sharp fa-light fa-circle-plus icon"></i>
                            <span class="sr-only">{{ labelPlus(what) }}</span>
                        </button>
                    </td>
                </tr>
                <!--<tr v-if="maxadults && ! maxbel">
                    <td colspan="3"
                        class="max-bel">
                        <div class="alert alert-danger"
                            role="alert">
                            {{ voMsg('tpl.text.maxAdultsReached') }}
                        </div>
                    </td>
                </tr>
                <tr v-if="maxbel">
                    <td colspan="3"
                        class="max-bel">
                        <div class="alert alert-danger"
                            role="alert">
                            {{ voMsg('tpl.text.maxOccupancyReached') }}
                        </div>
                    </td>
                </tr> -->
            </tbody>
        </table>
    </voffice-popup-box>
</template>

<script>
    import vofficePopupBox from './PopupBox.vue';

    export default {
    	voVueComponent: 'voffice-guestbox',
    	components: {
    		vofficePopupBox
    	},
    	voMsgCodes: [
    		'pet.pl',
    		'adult.pl',
    		'child.pl',
    		'baby.pl'
    	],
    	props: {
    		maxValues: Object,
    		minValues: Object,
    		searchData: Object,
    		showDogCountInSearch: Boolean,
    		triggerId: String,
    		applyLabel: String,
    		childrenWelcome: Boolean,
    		babysWelcome: Boolean,
    		petsWelcome: Boolean,
    		beds: [Number, String],
    		bedsForKids: [Number, String]
    	},
    	data() {
    		return {
    			maxbel: false,
    			maxadults: false
    		};
    	},
    	computed: {
    		sections() {
    			var res = {
    				'adults': 'adult'
    			};
    			if (VOFFICE.settings.childrenAges && this.childrenWelcome && this.babysWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    					'babys': 'baby'
    				});
    			} else if (this.childrenWelcome && this.babysWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    					'babys': 'baby'
    				});
    			} else if (this.childrenWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    				});
    			}
    			if (this.petsWelcome) {
    				res.petsCount = 'pet';
    			}
    			return res;
    		}
    	},
    	methods: {
    		check4Group: function(id) {
    			const el = document.querySelector('[data-groups]');
    			const groupsStr = el.getAttribute('data-groups');
    			const groups = JSON.parse(groupsStr);
    			const isIncluded = groups.includes(id);
    			//console.log('Group included:', isIncluded);
    			return isIncluded;
    		},
    		labelMinus(what) {
    			if (what === "adults") {
    				return this.voMsg('tpl.removeAdults');
    			} else if (what === "children") {
    				return this.voMsg('tpl.removeChildren');
    			} else if (what === "babys") {
    				return this.voMsg('tpl.removeBaby');
    			} else if (what === "petsCount") {
    				return this.voMsg('tpl.removePet');
    			}

    		},
    		labelPlus(what) {
    			if (what === "adults") {
    				return this.voMsg('tpl.addAdults');
    			} else if (what === "children") {
    				return this.voMsg('tpl.addChildren');
    			} else if (what === "babys") {
    				return this.voMsg('tpl.addBaby');
    			} else if (what === "petsCount") {
    				return this.voMsg('tpl.addPet');
    			}
    		},
    		onClosed() {
    			this.$emit('closed');
    		},
    		getFieldLabel(what) {
    			var amount = this.searchData[what] || 0;
    			return amount + ' ' + this.voMsgPl(this.sections[what] + '.pl', amount);
    		},
    		inc(what, step) {
    			this.searchData[what] = ((this.searchData[what] || 0) - 0) + step;
    			if (what == 'petsCount') {
    				this.searchData.p_16495 = this.searchData[what] > 0;
    			}
    		},
    		checkForAdults(what) {
    			let bedsForKids = parseInt(this.bedsForKids);
    			let beds = parseInt(this.beds) - bedsForKids;
    			if (parseInt(this.searchData['adults']) + parseInt(this.searchData['children']) >= this.beds) {
    				this.maxbel = true;
    				return false;
    			}
    			if (parseInt(this.searchData['adults']) >= beds) {
    				this.maxadults = true;
    				return false;
    			} else {
    				this.maxadults = false;
    				return true;
    			}
    		},
    		checkForChildren(what) {
    			if (parseInt(this.searchData['adults']) + parseInt(this.searchData['children']) >= this.beds) {
    				this.maxbel = true;
    				return false;
    			} else {
    				this.maxbel = false;
    				return true;
    			}
    		},
    		checkPersons(what) {
    			if (parseInt(this.searchData['adults']) + parseInt(this.searchData['children']) >= this.beds) {
    				this.maxbel = true;
    				return false;
    			} else {
    				this.maxbel = false;
    				return true;
    			}
    		},
    		canInc(what) {

    			var amount = ((this.searchData[what] || 0) - 0);
    			var max = this.maxValues && this.maxValues[what];
    			if (what === 'babys') {
    				if (this.maxValues && this.maxValues['babys']) {
    					max = this.maxValues['babys'];

    				} else {
    					max = 2;
    				}
    			}
    			if (max != undefined && amount >= max) {
    				return false;
    			}
    			if (VOFFICE.settings.check4MaxBeds) {
    				if (parseInt(this.bedsForKids) > 0) {
    					if (what === 'adults') {
    						return this.checkForAdults(what);
    					}
    					if (what === 'children') {
    						return this.checkForChildren(what);
    					}

    				} else {
    					if (what === 'adults' || what === 'children') {
    						if (this.beds && parseInt(this.beds) > 0) {
    							return this.checkPersons(what);
    						}
    					}
    				}
    			}
    			if (what === 'petsCount') {
    				if (this.searchData['petsCount'] >= 2) {
    					return false;
    				}
    			}
    			return true;
    		},
    		canDecr(what) {
    			var amount = ((this.searchData[what] || 0) - 0);
    			var min = this.minValues && this.minValues[what];
    			if (min == undefined) {
    				min = what == 'adults' ? 1 : 0
    			}
    			if (min != undefined && amount <= min) {
    				return false;
    			}
    			return true;
    		}
    	}
    };
</script>

<style scoped>
    .guestbox {
    	margin: 0 auto;
    	line-height: 46px;
    	text-align: left;
    	font-size: 15px;
    	color: #676767;
    }

    .gb-td {
    	padding: 8px 12px;
    }

    .gb-td.label {
    	line-height: 1;
    }

    .age {
    	font-size: 14px;
    	padding-top: 5px;
    }

    .alert-danger {
    	line-height: 20px;
    }

    .icon {
    	position: unset !important;
    	font-size: 40px !important;
    	opacity: 1 !important;
    }

    .btn {
    	width: 48px;
    	height: 48px;
    	line-height: 1;
    	border: none;
    	font-size: 40px;
    	padding: 4px;
    	color: #a7a4a4;
    }

    .btn:hover {
    	background-color: transparent;
    	color: var(--color-primary);
    }

    .btn:focus {
    	background-color: transparent;
    	color: var(--color-primary);
    }

    .btn.disabled,
    .btn:disabled {
    	color: #bbb9b9;
    }

    .label {
    	white-space: nowrap;
    }

    @media (max-width: 768px) {}
</style>